import FrequentlyAskedQuestion from "@components/FrequentlyAskedQuestion"
import { useTranslation } from "react-i18next"

export default function FrequentlyAskedQuestions() {
  const { t } = useTranslation()

  return (
    <>
      <h2 className="custom-heading mb-8">{t("components.faq.heading")}</h2>

      <div className="space-y-6">
        <FrequentlyAskedQuestion
          text={t("components.faq.whatCanIDoWithThatAppDesc")}
          title={t("components.faq.whatCanIDoWithThatAppTitle")}
        />

        <FrequentlyAskedQuestion
          text={t("components.faq.howToGetAccessText")}
          title={t("components.faq.howToGetAccessTitle")}
        />

        <FrequentlyAskedQuestion
          text={t("components.faq.howToCancelText")}
          title={t("components.faq.howToCancelTitle")}
        />
      </div>
    </>
  )
}
